export default "<router-outlet></router-outlet>\n<!-- <app-page-loader></app-page-loader> -->"